<template>
  <div class="container-fluid text-left">
    <!-- <div class="col-12" v-if="1 == 3">
      <div class="row tt_x_10 tt_10 b_x">
        <div class="col-3 middle col-00">
          <h4 class="z_15">组织名称</h4>
        </div>
        <div class="col-9 middle col-00">
          <input class="z_15" type="text" placeholder="请填写组织名称" name="" id="" v-model="ClusterTitle" />
        </div>
      </div>
      <div class="row  tt_x_10 tt_10 b_x">
        <div class="col-3 middle col-00">
          <h4 class="z_15">联系姓名</h4>
        </div>
        <div class="col-9 middle col-00">
          <input class="z_15" type="text" placeholder="请填写联系姓名" name="" id="" v-model="ClusterName" />
        </div>
      </div>

      <div class="row  tt_x_10 tt_10 b_x">
        <div class="col-3 middle col-00">
          <h4 class="z_15">联系电话</h4>
        </div>
        <div class="col-9 middle col-00">
          <input class="z_15" type="text" placeholder="请填写联系电话" name="" id="" v-model="ClusterTel" @change="check" />
        </div>
        <p v-if="err" style="color: red;margin: 0;">手机号码不正确</p>
      </div>

      <div class="row  tt_x_10 tt_10 b_x">
        <div class="col-3 middle col-00">
          <h4 class="z_15">联系地址</h4>
        </div>
        <div class="col-9 middle col-00">
          <input class="z_15" type="text" placeholder="请填写联系地址" name="" id="" v-model="ClusterAdd" />
        </div>
      </div>
      <div class="tt_10" style="margin: 0 -15px;">
        <div style="border-bottom: 1px solid #e5e5e5;">
          <van-field readonly clickable label="所属社区" :value="community" v-model="value" placeholder="选择社区"
            @click="showPicker = true"
            style="padding-left:0;padding-top:5px;padding-bottom:15px;font-size:15px;color:$2c3e50;margin-right:0;" />
          <van-popup v-model="showPicker" round position="bottom">
            <van-picker show-toolbar :columns="saddress" @cancel="showPicker = false" @confirm="onConfirm"
              title="所属社区" />
          </van-popup>
        </div>
      </div>

      <div class="row  tt_x_10 tt_10">
        <div class="col-3 middle col-00">
          <h4 class="z_15">组织简介</h4>
        </div>
        <div class="col-12 middle col-00">
          <textarea rows="5" class="input-group" placeholder="描述您的需求内容" v-model="ClusterExplain"></textarea>
        </div>
      </div>

      <div class="row tt_x_10 tt_10">
        <div class="col-6 col-00  middle text-left">
          <h4 class="z_15">组织LOGO</h4>
        </div>
        <div class="col-12 middle col-00">
          <label class="label111">
            <input type="file" style="display:none" ref="adFile" @change="adChange">
            <div class="imgsaa" v-if="editImg!= '' ">
              <img :src=editImg alt="" style="width:100%">
            </div>
            <div class="imgsaa" v-else-if="avatar_url!= '' ">
              <img :src=avatar_url alt="" style="width:100%">
            </div>
            <div class="add_btn" v-else></div>
          </label>
        </div>
      </div>

      <div class="col-12">
        <button class='submit_btn' @click="Clusterbtn()">提交资料</button>
      </div>

    </div> -->
    <div class="col-12">
      <div class="row tt_x_10 tt_10 b_x">
        <div class="col-3 middle col-00">
          <h4 class="z_15">联系姓名</h4>
        </div>
        <div class="col-9 middle col-00">
          <!-- <input class="z_15" type="text" placeholder="请填写联系姓名" name="" id="" v-model="ClusterName" /> -->
          {{ ClusterName | name }}
        </div>
      </div>

      <div class="row tt_x_10 tt_10 b_x">
        <div class="col-3 middle col-00">
          <h4 class="z_15">联系电话</h4>
        </div>
        <div class="col-9 middle col-00">
          {{ ClusterTel | phone }}
          <!-- <input class="z_15" type="text" placeholder="请填写联系电话" name="" id="" v-model="ClusterTel" @change="check" /> -->
        </div>
        <!-- <p v-if="err" style="color: red;margin: 0;">手机号码不正确</p> -->
      </div>

      <div class="row tt_x_10 tt_10 b_x">
        <div class="col-3 middle col-00">
          <h4 class="z_15">联系地址</h4>
        </div>
        <div class="col-9 middle col-00">
          <input
            class="z_15"
            type="text"
            placeholder="请填写联系地址"
            name=""
            id=""
            v-model="ClusterAdd"
          />
        </div>
      </div>
      <div class="row b_x">
        <div class="col-3 middle col-00">
          <h4 class="z_15">所属社区</h4>
        </div>
        <div class="col-9 middle col-00">
          <div class="tt_10">
            <div>
              <van-field
                readonly
                clickable
                label=""
                :value="community"
                v-model="value"
                placeholder="选择社区"
                @click="showPicker = true"
                style="
                  padding-left: 0;
                  padding-top: 5px;
                  padding-bottom: 15px;
                  font-size: 15px;
                  color: $2c3e50;
                  margin-right: 0;
                "
              />
              <van-popup v-model="showPicker" round position="bottom">
                <van-picker
                  show-toolbar
                  :columns="saddress"
                  @cancel="showPicker = false"
                  @confirm="onConfirm"
                  title="所属社区"
                />
              </van-popup>
            </div>
          </div>
        </div>
      </div>

      <!--  <div class="row  tt_x_10 tt_10 b_x">
        <div class="col-3 middle col-00">
          <h4 class="z_15">服务范围</h4>
        </div>
        <div class="col-9 middle col-00">
          <input class="z_15" type="text" placeholder="请填写服务范围" name="" id="" v-model="ClusterRange" />
        </div>
      </div> -->

      <div class="row b_x">
        <div class="col-3 middle col-00">
          <h4 class="z_15">所属组织</h4>
        </div>
        <div class="col-9 middle col-00">
          <div class="tt_10">
            <div>
              <van-field
                readonly
                clickable
                label=""
                :value="organization"
                v-model="value1"
                placeholder="选择组织"
                @click="showPicker1 = true"
                style="
                  padding-left: 0;
                  padding-top: 5px;
                  padding-bottom: 15px;
                  font-size: 15px;
                  color: $2c3e50;
                  margin-right: 0;
                "
              />
              <van-popup v-model="showPicker1" round position="bottom">
                <van-picker
                  show-toolbar
                  :columns="caddress"
                  @cancel="showPicker1 = false"
                  @confirm="onConfirm1"
                  title="加入组织"
                />
              </van-popup>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="row  tt_x_10 tt_10 b_x">
        <div class="col-3 middle col-00">
          <h4 class="z_15">加入组织</h4>
        </div>
        <div class="col-9 middle col-00">
          <select v-model="community">
            <option v-for="(option,aa) in caddress" :key="aa" v-bind:value="aa">
              {{ option.value }}
            </option>
          </select>
        </div>
      </div> -->
      <div class="row tt_x_10 tt_10">
        <div class="col-6 col-00 middle text-left" style="margin-bottom: 10px">
          <h4 class="z_15">个人头像</h4>
        </div>
        <div class="col-12 middle col-00">
          <label class="label111">
            <input
              type="file"
              style="display: none"
              ref="adFile"
              @change="adChange"
              accept="image/png,image/jpeg"
            />
            <div class="imgsaa" v-if="editImg != ''">
              <img :src="editImg" alt="" style="width: 100%" />
            </div>
            <div class="imgsaa" v-else-if="avatar_url != ''">
              <img :src="avatar_url" alt="" style="width: 100%" />
            </div>
            <div class="add_btn2" v-else>
              <img src="../../assets/add.png" />
            </div>
          </label>
        </div>
      </div>

      <div class="col-12">
        <button class="submit_btn" @click="Clusterbtn()">提交资料</button>
      </div>
    </div>
    <div id="d_p_80"></div>
    <pop :show5="showji" message="修改成功" @editshow="editshow" />
  </div>
</template>
<script>
import pop from "./popup.vue";
export default {
  data() {
    return {
      organization: "暂无关联",
      community: "暂无关联",
      showPicker: false,
      showPicker1: false,
      caddress: [],
      saddress: [],
      // columns1: ['1', '2', '3', '4'],
      showji: false,
      avatar_url: null,
      err: 0,
      current: 0,
      Cluster: "",
      ClusterExplain: "",
      ClusterRange: "",
      ClusterAdd: "",
      ClusterTel: "",
      ClusterName: "",
      ClusterTitle: "",
      editImg: "",
      editFiles: "",
      time: 5,
      timer: null,
      id: "",
      value: "",
      value1: "",
      aa: [],
      bb: [],
    };
  },
  components: {
    pop,
  },
  props: {},
  created() {},
  mounted() {
    const info_id = this.$api.getUserInfo().id;
    // console.log(info_id);
    //return
    this.$api
      .getAPI(
        "mutual/attribute/" +
          info_id +
          "?appid=202108&type_id=4001&redis_time=3",
        {}
      )
      .then((res) => {
        // console.log(res.data.data.models);
        if (res.data.data.models.key_id == 0) {
          res.data.data.models.key_id = 3;
        }
        this.Cluster = res.data.data.models.key_id;
        this.ClusterExplain = res.data.data.models.explain;
        this.ClusterRange = res.data.data.models.range;
        this.ClusterAdd = res.data.data.models.address;
        // if (!this.ClusterAdd) {
        // } else {
        //   this.ClusterAdd = this.ClusterAdd.substring(0, 6) + "*****" + this.ClusterAdd.substring(this.ClusterAdd.length - 4)
        // }
        this.ClusterTel = res.data.data.models.telephone;
        this.ClusterName = res.data.data.models.username;
        this.ClusterTitle = res.data.data.models.title;
        this.avatar_url = res.data.data.models.avatar_url;
        this.id = res.data.data.models.id;
        this.community = res.data.data.models.community;
        this.organization = res.data.data.models.ojb_id;
        // console.log(this.organization);
        if (this.organization == 0) {
          this.organization = 0;
        }
        if (this.community == 0) {
          this.community = 0;
        }
        // console.log(this.community);
        // console.log(this.editImg);
        this.$api.getAPI("build/app/202108?state=1", {}).then((res) => {
          // console.log(res.data.data.frame_users);
          this.bb = res.data.data.frame_users;
          this.saddress.push("暂无关联");
          for (let i = 0; i < res.data.data.frame_users.length; i++) {
            this.saddress.push(res.data.data.frame_users[i].value);
            // console.log(this.saddress);
            if (res.data.data.frame_users[i].id == this.community) {
              this.value = res.data.data.frame_users[i].value;
              // console.log(this.value);
            }
          }
          // console.log(this.saddress);
          this.$api
            .getAPI(
              "mutual/attribute/?appid=202108&type_id=4001&key_id=1&size=200",
              {}
            )
            .then((res) => {
              this.caddress.push("暂无关联");
              for (let i = 0; i < res.data.data.data[0].models.length; i++) {
                // console.log(res.data.data.data[0].models[i]);
                this.aa.push(res.data.data.data[0].models[i]);
                this.caddress.push(res.data.data.data[0].models[i].title);
                if (res.data.data.data[0].models[i].id === this.organization) {
                  // console.log(i);
                  this.value1 = res.data.data.data[0].models[i].title;
                }
              }
              this.$api
                .getAPI(
                  "mutual/attribute/?appid=202108&type_id=4001&key_id=2&size=500",
                  {}
                )
                .then((res) => {
                  for (
                    let i = 0;
                    i < res.data.data.data[0].models.length;
                    i++
                  ) {
                    // console.log(res.data.data.data[0].models[i]);
                    this.aa.push(res.data.data.data[0].models[i]);
                    this.caddress.push(res.data.data.data[0].models[i].title);
                    if (
                      res.data.data.data[0].models[i].id === this.organization
                    ) {
                      // console.log(i);
                      this.value1 = res.data.data.data[0].models[i].title;
                    }
                  }
                  // console.log(this.value1);
                  // console.log(this.caddress);
                });
            });
        });
      });
    if (this.value1 == "") {
      this.value1 = "暂无关联";
    }
    if (this.value == "") {
      this.value = "暂无关联";
    }
  },
  methods: {
    onConfirm(value, value_key) {
      console.log(value, value_key);
      this.value = value;
      for (let i = 0; i < this.bb.length; i++) {
        if (this.bb[i].value == value) {
          this.community = this.bb[i].id;
        }
      }
      if (value == "暂无关联") {
        this.community = 0;
      }
      this.showPicker = false;
      // console.log(this.community);
    },
    onConfirm1(value, value_key) {
      // console.log(value, value_key);
      this.value1 = value;
      // this.organization = value_key;
      this.showPicker1 = false;
      // console.log(this.aa[0].title);
      for (let i = 0; i < this.aa.length; i++) {
        if (this.aa[i].title == this.value1) {
          this.organization = this.aa[i].id;
        }
      }
      if (value == "暂无关联") {
        this.organization = 0;
      }
      // console.log(this.value1, this.organization);
    },
    editshow() {
      this.showji = false;
      this.$router.push("/home_users");
    },
    Clusterbtn() {
      const info = this.$api.getUserInfo();
      let data = new FormData();
      // data.append('key_id', this.Cluster)
      data.append("title", this.ClusterTitle);
      data.append("username", this.ClusterName);
      data.append("telephone", this.ClusterTel);
      data.append("address", this.ClusterAdd);
      data.append("range", this.ClusterRange);
      data.append("explain", this.ClusterExplain);
      //data.append('openid', info.openid)
      data.append("avatar_url", this.avatar_url);
      data.append("community", this.community);
      data.append("ojb_id", this.organization);
      // console.log(this.avatar_url);
      this.$api
        .postAPI(
          `mutual/attribute/` +
            this.id +
            `?appid=202108&type_id=4001&state=1&redis_time=1&openid=` +
            info.openid,
          data
        )
        .then((res) => {
          this.$router.push("/home_users");
          if (res.data.code == 200) {
            this.$Message.success("修改成功！");
          }
          // alert('修改成功')
          // this.$router.push('/home_users')
          // window.localStorage.setItem('openid', 2354414)
          // this.show = true
          // this.timer = setInterval(() => {
          //   this.time--
          //   if (this.time < 1) {
          //     clearInterval(this.timer)
          //     this.timer = null
          //     this.show = false
          //     this.$router.push('/server_project_release')
          //   }
          // }, 1000)
        });
    },
    check() {
      if (!/^1[34578]\d{9}$/.test(this.ClusterTel)) {
        this.err = 1;
        // console.log(1);
        return false;
      } else {
        this.err = 0;
      }
      // console.log(this.err);
    },
    adChange(e) {
      // console.log(e);
      // console.log(this.$refs.adFile.files[0]);

      let $target = e.target || e.srcElement;
      let file = $target.files[0];
      // console.log(file);
      var reader = new FileReader();
      reader.onload = (data) => {
        let res = data.target || data.srcElement;
        this.editImg = res.result;
      };
      reader.readAsDataURL(file);
      this.editFiles = file;
      // console.log(this.editFiles);
      let formData = new FormData();
      formData.append("fileName", this.editFiles);
      // console.log(this.avatar_url);
      this.$api.postAPI(`default/upload/?state=1`, formData).then((res) => {
        this.avatar_url = res.data.url;
        // console.log(this.avatar_url);
      });
    },
  },
  filters: {
    name(value) {
      if (!value) return "";
      let str = value;
      str = str
        .toString()
        .replace(/^([^\x00-\xff])([^\x00-\xff]{0,})([^\x00-\xff])/g, "$1*$3");
      return str;
    },
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      // return value.charAt(0).toUpperCase() + value.slice(1)
      // console.log(value.substring(0, 2) + "*****" + value.substring(value.length - 2));
      return (
        value.substring(0, 6) + "*****" + value.substring(value.length - 4)
      );
    },
    phone(str) {
      if (null != str && str != undefined) {
        var pat = /(\d{3})\d*(\d{4})/;
        return str.replace(pat, "$1****$2");
      } else {
        return "";
      }
    },
  },
};
</script>
<style>
input {
  padding-left: 2px !important;
}

.van-picker__toolbar button {
  /* color: #f00; */
  margin-top: 0;
  width: 60px;
  padding: 0 16px;
  margin-left: 0;
  background: none !important;
  border-radius: 0;
}

.submit_btn {
  margin-top: 20px;
  bottom: 0;
  width: 100%;
  border: 0;
  text-align: center;
  line-height: 3em;
  font-size: 1em;
  color: #ffffff;
  background: #01b2c2;
  cursor: pointer;
  margin-left: 0;
  height: auto;
}

h4 {
  color: #646566;
}

select {
  border-radius: 5px;
  border: 1px solid #777;
  padding: 3px;
  background: none;
}

.pop {
  width: 100%;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.15);
  z-index: 99;
}

.edit2 {
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  height: 150px;
  background: #fff;
  z-index: 990;
  overflow: hidden;
  border-radius: 20px;
  padding: 10px 20px;
  box-shadow: 0px 1px 3px 1px rgb(0 0 0 / 15%);
}

.edit2 button {
  height: 35px;
  width: 150px;
  border-radius: 3px;
  border: none;
  background: #1890ff;
  color: #fff;
  margin-left: 10px;
  cursor: pointer;
  margin: 6px auto 10px;
  /*
  margin-top:
  25px;
  */
  text-align: center !important;
}

/*
  .active
  {
  font-size:
  16px
   !important;
  color:
  #1890ff
   !important;
  }
  */
.top-fluid {
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.switch {
  outline: none !important;
  margin-left: -6px;
  margin-right: 15px;
  background: none;
  color: #7b7b7b;
  border: none;
  font-size: 14px;
  text-align: left !important;
}

.col-00 {
  padding-right: 0px;
  padding-left: 0px;
}

textarea {
  padding: 8px;
  border: 1px dashed #e5e5e5;
}

.add_btn2 {
  width: 80px;
  height: 80px;
  border: 1px dashed #e5e5e5;
  position: relative;
  /* background: url(https://www.17sucai.com/preview/61021/2020-01-20/%E5%B8%A6%E7%BC%A9%E7%95%A5%E5%9B%BE%E7%9A%84%E5%9B%BE%E7%89%87%E4%B8%8A%E4%BC%A0/imgs/add.png)
    no-repeat 50% 50%; */
  cursor: pointer;
}

.add_btn2 img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.label111 {
  width: 100%;
  height: 80px;
}

.imgsaa {
  width: 80px;
  height: 80px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.nav a {
  color: #01b2c2;
}
</style>



// WEBPACK FOOTER //
// src/components/views/modifydata.vue